import React from 'react';
import s from './EmptyState.module.scss';

interface EmptyStateProps {
    onStartConfiguring: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    onStartConfiguring,
}) => {
    return (
        <div className={s.empty_state}>
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect
                    x="8"
                    y="12"
                    width="32"
                    height="28"
                    rx="3"
                    stroke="#ced4da"
                    strokeWidth="2"
                />
                <path
                    d="M16 20h16M16 26h10"
                    stroke="#ced4da"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <circle
                    cx="36"
                    cy="12"
                    r="6"
                    fill="#e9ecef"
                    stroke="#ced4da"
                    strokeWidth="2"
                />
                <path
                    d="M36 9v6M33 12h6"
                    stroke="#ced4da"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </svg>
            <div className={s.empty_state_title}>No accessories added</div>
            <div className={s.empty_state_text}>
                Go back to the configurator and select parts to build your Jeep.
            </div>
            <button className={s.empty_state_btn} onClick={onStartConfiguring}>
                Start configuring
            </button>
        </div>
    );
};
